var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h2',[_vm._v(" IN-PATIENT CARE ")]),_c('h4',[_vm._v(" Medical services/procedures rendered to an HMI member who has been admitted to a hospital as a registered bed patient under the supervision/direction of an HMI PIC at his designated MSU. ")])])
}]

export { render, staticRenderFns }